import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onDrop"]
const _hoisted_4 = { class: "flex flex-col items-center gap-3 max-w-xl text-center p-8" }
const _hoisted_5 = { class: "inline-flex shadow-sm text-gray-600 p-3 rounded-sm border border-gray-200" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "dropzoneFile",
    class: "text-primary-700 font-medium cursor-pointer"
  }, "Click to upload"),
  /*#__PURE__*/_createTextVNode(" or drag and drop files into this box. If your file is an image you may use the crop and edit tool.")
], -1)
const _hoisted_7 = ["multiple"]
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center error border rounded-sm mt-5"
}
const _hoisted_9 = { class: "flex flex-col items-center gap-3 max-w-xl text-center p-5" }
const _hoisted_10 = { class: "inline-flex shadow-sm text-gray-600 p-3 rounded-sm border border-gray-200 error" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-700 font-medium" }, "Oops! "),
  /*#__PURE__*/_createTextVNode(" There has been an error with your file upload. Please try the files marked red again.")
], -1)
const _hoisted_12 = {
  id: "files",
  class: "grid grid-cols-3 gap-5 pt-10 pb-10 rounded-b-lg"
}
const _hoisted_13 = {
  key: 0,
  class: "border-2 rounded-sm border-gray-blue-300 dark:border-gray-bluer-400"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex p-3 pb-1 border-b-2 border-gray-blue-300 dark:border-gray-bluer-400 justify-center font-bold" }, " Replacing... ", -1)
const _hoisted_15 = { class: "p-3" }
const _hoisted_16 = { class: "group relative flex-shrink-0 w-full" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "image-thumbnail-image flex items-center justify-center bg-gray-blue-500 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase"
}
const _hoisted_19 = { class: "flex items-center justify-between space-x-3 mt-3" }
const _hoisted_20 = { class: "font-bold text-gray-bluer-300 text-sm truncate" }
const _hoisted_21 = { class: "font-bold text-gray-bluer-200 text-xs uppercase" }
const _hoisted_22 = {
  key: 1,
  class: "rounded-sm justify-center items-center flex border-gray-blue-300 dark:border-gray-bluer-400"
}
const _hoisted_23 = { class: "border-2 rounded-sm border-gray-blue-300 dark:border-gray-bluer-400" }
const _hoisted_24 = { class: "flex p-3 pb-1 border-b-2 border-gray-blue-300 dark:border-gray-bluer-400 justify-between" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_27 = {
  key: 1,
  class: "font-bold error"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "p-3" }
const _hoisted_30 = { class: "group relative flex-shrink-0 w-full" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 4,
  class: "image-thumbnail-image flex items-center justify-center bg-gray-blue-500 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase"
}
const _hoisted_33 = { class: "flex items-center justify-between space-x-3 mt-3" }
const _hoisted_34 = { class: "font-bold text-gray-bluer-300 text-sm truncate" }
const _hoisted_35 = { class: "font-bold text-gray-bluer-200 text-xs uppercase" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Replace ")
const _hoisted_38 = { key: 1 }

import { toRefs, computed, ref, watch } from "vue";
import { useStore }              from "vuex";
import { userHook }              from "@/hooks/user";
import { useConfig }             from "../config";

// Components
import { 
    AppButton as Button,
    AppLoader as Loader
    } from "@greywind/ui";
import { MediaEditor } from '../editor';


export default /*#__PURE__*/_defineComponent({
  props: {
        model:         {
            type:     Object,
            required: true
        },
        canBulkUpload: {
            type:     Boolean,
            required: false,
            default:  true
        },
        file:          {
            type:     Object,
            required: false,
            default:  null
        }
    },
  emits: [ 'reload', 'close' ],
  setup(__props, { emit }) {

const props = __props


const { model, canBulkUpload, file } = toRefs( props );

const store            = useStore();
const { activeClient, activeEnvironment } = userHook( store );
const { config }       = useConfig();

const stashed          = ref( false );
const path   = computed( () => store.state.media.path );

const fileInput = ref(null);
const cropper = ref( {
  open: false,
  index: 0,
  coordinates: {},
  image: null,
} );
const filesActive = ref(false);
const files = ref<any>([]);

const hasUploadError = computed(() => {
    return files.value.filter((file) => {
        return file.error === true;
    }).length > 0;
});

const isUploading = computed(() => {
    return files.value.filter((file) => {
        return file.uploading === true;
    }).length > 0;
});

const canUpload = computed(() => {
    return files.value.filter((file) => {
        return file.uploaded === false;
    }).length > 0;
});

const fileMode = computed(() => {
    if (file.value !== null) {
        return 'replace';
    }

    return 'upload';
});

const openCropper = ( index: number ) => {
    cropper.value.index = index;
    cropper.value.open = true;
}

const removeFile = ( index: number ) => {
    /** remove from files array */
    files.value.splice(index, 1);

    /** remove file from file input, so user can add it back if it is removed accidentally */
    const dt = new DataTransfer();
    const fileList = fileInput.value.files;

    for ( let i=0; i < fileList.length; i++ ) {
        const file = fileList[i];
        if ( index !== i ) {
            dt.items.add(file);
        }
    }

    fileInput.value.files = dt.files;
}

const onImageDrop = async (event: any) => {
    await handleFileUpload( event.dataTransfer.files ?? [] );
    filesActive.value = false;
}

const onImageSelect = async (event: any) => {
    await handleFileUpload( event.target.files ?? [] );
}

const handleFileUpload = async ( fileList: FileList) => {

    /** if replacing a file, clear the list so only the new file is present */
    if (fileMode.value == 'replace') files.value = [];

    [ ...fileList ].forEach( async file => {
        const isImage = fileIsImage(file.type)
        if (isImage) {
            const data = await toBase64( file );
            const { width, height }: { width: number; height: number; } = await new Promise( (resolve, reject) => {
                try {
                    const image = new Image();
                    image.src = data as string;

                    image.onload = () => resolve( { width: image.width, height: image.height } );
                } catch (e) {
                    reject(e);
                }
            } );

            files.value.push( {
                data: data,
                name: file.name,
                size: file.size,
                width: width ?? null,
                height: height ?? null,
                mimetype: file.type,
                uploading: false,
                isImage: true,
                error: false,
                uploaded: false
            } );
        } else {
            files.value.push( {
                data: file,
                name: file.name,
                size: file.size,
                mimetype: file.type,
                uploading: false,
                isImage: false,
                error: false,
                uploaded: false
            } );
        }

  } );
}

const saveCropping = async ( { croppedImage, transforms } ) => {
    files.value[ cropper.value.index ].data = croppedImage
    files.value[ cropper.value.index ].width = transforms.width;
    files.value[ cropper.value.index ].height = transforms.height;

    const strLength = croppedImage.length - `data:${files.value[cropper.value.index].mimetype ?? 'image/jpeg'};base64,`.length;
    files.value[ cropper.value.index ].size =  4 * Math.ceil( ( strLength / 3 ) ) * 0.5624896334383812;

    cropper.value.open = false;
    cropper.value.image = null;
}

/** replace existing file with new upload */
const replace = async () => {
    const uploadedFile = files.value[0];
    const replacement = uploadedFile.isImage ? await base64ListToFiles( [files.value[0]] ).then(result => result[0]) : files.value[0].data;
    
    uploadedFile.uploading = true;
    uploadedFile.error = false;
    uploadedFile.uploaded = false;

    const tempResult = await uploadTempFile( replacement )
        .then((result) => {
            model.value.replace( file.value.id, { file: result } )
            .then(async () => {
                uploadedFile.uploading = false;
                uploadedFile.error = false;
                uploadedFile.uploaded = true;

                await store.dispatch('media/getFiles');
            })
            .catch(() => {
                uploadedFile.uploading = false;
                uploadedFile.error = true;
                uploadedFile.uploaded = false;
            });
        })
        .catch((error) => {
            uploadedFile.uploading = false;
            uploadedFile.error = true;
            uploadedFile.uploaded = false;
        });
}

const uploadTempFile = async ( file: File ) => {
    return new Promise(async ( resolve, reject ) => {
        const formData = new FormData();
        formData.append("file", file);

        await model.value.uploadTemp( formData )
        .then((result) => {
            resolve(result.data);
        })
        .catch((error) => {
            reject(error);
        });
    });
}

/** handle upload of all new files */
const upload = async () => {
    const imageFiles = await base64ListToFiles( files.value.filter(( file ) => {
        return file.isImage === true;
    }));

    const fileFiles = files.value.filter(( file ) => {
        return file.isImage === false;
    }).map(( file ) => {
        return file.data;
    })

    const allFiles = [...imageFiles, ...fileFiles];

    const result = await Promise.all( allFiles.map( (file, i) => uploadFile(file, i)) );
    result.map(( success, i) => {
        if ( success ) {
            files.value[i].uploaded = true;
            files.value[i].error = false;
        } else {
            files.value[i].uploaded = false;
            files.value[i].error = true;
        }
    });
    
    if (result.filter((res) => res === true ).length > 0 ) {
        await store.dispatch('media/getFiles');
    }
}

/** upload single file */
const uploadFile = async (file: File, fileIndex: number) => {
    if (files.value[fileIndex].uploaded === true) return true;

    files.value[fileIndex].uploading = true;
    files.value[fileIndex].error = false;
    const formData = new FormData();
    formData.append("file", file);
    
    /** if we are in a folder then add the path to request */
    if(path.value != null && path.value != 'null' ) formData.append('path', path.value);

    const fileUploadResult = await uploadTempFile(file)
    .then(async (result) => {
         /** upload to main disk */   
        return await model.value.upload( formData )
        .then(() => {
            files.value[fileIndex].uploading = false;
            files.value[fileIndex].uploaded = true;
            files.value[fileIndex].error = false;

            return true;
        })
        .catch(() => {
            files.value[fileIndex].uploading = false;
            files.value[fileIndex].uploaded = false;
            files.value[fileIndex].error = true;

            return false;
        });
    })
    .catch((error) => {
        files.value[0].uploading = false;
        files.value[0].error = true;
        files.value[0].uploaded = false;
        return false;
    });

    return fileUploadResult;
}

const toBase64 = async ( file: File ) => new Promise( (resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
} );

const base64ListToFiles = async (images: any[]) => {
    const uploadList: File[] = [];

    for (const key in images) {
        const img = images[key];

        if (!img?.id && img.data) {
            // This is an image for upload
            const res: Response = await fetch(img.data);
            const blob: Blob = await res.blob();

            uploadList.push(new File([blob], img.name, { type: img.mimetype }));
        }
    }

  return uploadList;
};

const fileIsImage = (type: string): Boolean => {
    return ['image/jpeg', 'image/png'].includes(type);
}


return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_popper = _resolveComponent("x-popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!cropper.value.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onDragenter: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (filesActive.value = true), ["prevent"])),
            onDragleave: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (filesActive.value = false), ["prevent"])),
            onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _withModifiers(onImageDrop, ["prevent"]),
            class: _normalizeClass(['flex justify-center items-center rounded-sm relative border', !filesActive.value && 'border-gray-200', filesActive.value && 'border-primary'])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_x_icon, {
                  icon: "fontawesome.cloud-upload",
                  "fa-type": "fas",
                  class: "h-7 w-7"
                })
              ]),
              _hoisted_6,
              _createElementVNode("input", {
                type: "file",
                ref_key: "fileInput",
                ref: fileInput,
                id: "dropzoneFile",
                class: "absolute invisible",
                accept: "image/jpeg, image/png, image/gif, video/mp4, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, audio/wav, audio/mp3 ",
                multiple: _unref(fileMode) == 'upload',
                onChange: onImageSelect
              }, null, 40, _hoisted_7)
            ])
          ], 42, _hoisted_3),
          (_unref(hasUploadError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_x_icon, {
                      icon: "fontawesome.triangle-exclamation",
                      "fa-type": "fas",
                      class: "h-7 w-7"
                    })
                  ]),
                  _hoisted_11
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            (_unref(fileMode) == 'replace')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_unref(file).is_image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(file).url,
                            class: "image-thumbnail-image rounded-sm"
                          }, null, 8, _hoisted_17))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(file).file_name.split( '.' ).pop()), 1))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(file).name ?? _unref(file).file_name), 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(file).file_name.split( '.' ).pop()), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(fileMode) == 'replace')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_x_icon, {
                    icon: "fontawesome.arrow-right",
                    "fa-type": "fas",
                    class: "h-10 w-10"
                  })
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    (file.isImage && !file.uploaded)
                      ? (_openBlock(), _createBlock(_component_x_popper, {
                          key: 0,
                          arrow: "",
                          hover: "",
                          content: "Crop/Resize"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
                              onClick: _withModifiers(($event: any) => (openCropper(i)), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.crop",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_25)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  (file.uploaded && !file.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(fileMode) == 'replace' ? 'Replacement' : 'Upload') + " Successful ", 1))
                    : _createCommentVNode("", true),
                  (file.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Upload Failed "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (!file.uploaded)
                      ? (_openBlock(), _createBlock(_component_x_popper, {
                          key: 0,
                          arrow: "",
                          hover: "",
                          content: "Delete"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                              onClick: _withModifiers(($event: any) => (removeFile(i)), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.trash",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_28)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (file.uploaded)
                      ? (_openBlock(), _createBlock(_component_x_icon, {
                          key: 0,
                          icon: "fontawesome.check",
                          "fa-type": "fas",
                          class: "h-10 w-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 uploaded file-status-container",
                          style: {}
                        }))
                      : _createCommentVNode("", true),
                    (file.error)
                      ? (_openBlock(), _createBlock(_component_x_icon, {
                          key: 1,
                          icon: "fontawesome.exclamation",
                          "fa-type": "fas",
                          class: "h-10 w-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 error file-status-container",
                          style: {"z-index":"100","background-color":"white","border-radius":"50%","padding":"30px"}
                        }))
                      : _createCommentVNode("", true),
                    (file.uploading)
                      ? (_openBlock(), _createBlock(_unref(Loader), {
                          key: 2,
                          class: "text-theme-500"
                        }))
                      : _createCommentVNode("", true),
                    (file.isImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 3,
                          src: file.data,
                          class: "image-thumbnail-image rounded-sm"
                        }, null, 8, _hoisted_31))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(file.name.split( '.' ).pop()), 1))
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(file.name), 1),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(file.name.split( '.' ).pop()), 1)
                  ])
                ])
              ]))
            }), 256))
          ]),
          (_unref(canUpload) && _unref(fileMode) == 'upload')
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                onClick: upload
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canUpload) && _unref(fileMode) == 'replace')
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 2,
                onClick: replace
              }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (cropper.value.open && cropper.value.index < files.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_unref(MediaEditor), {
            image: files.value[ cropper.value.index ]?.data,
            "image-type": files.value[cropper.value.index].mimetype,
            onApply: saveCropping
          }, null, 8, ["image", "image-type"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})